// HomeWeb.jsx
import React, {useState, useEffect} from 'react';
import { Text,Modal, ScrollView, View, Image, TouchableOpacity, Platform, Linking } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import BaseWeb from './components/baseWeb';
import styles from './styles/celerWebStyles';
import { Ionicons, FontAwesome5 } from '@expo/vector-icons';
import { useLogScreen } from '../useLogScreen';
export default function AnaliseDeCertidoesWeb() {
    useLogScreen('AnaliseDocumental');
    useEffect(() => {
        if (Platform.OS === 'web') {
            setTimeout(() => {
                document.title = 'imoGo | Emissão de Certidões';
            }, 100);
        }
    }, []);
    const navigation = useNavigation();
    const [modalVisible, setModalVisible] = useState(false); // Controla o primeiro modal (categoria)
    const closeMenu = () => setModalVisible(false);
    return (
        <BaseWeb>
            {(userInfo) => {
                const usuario_id = userInfo?.id;
                return (
                    <ScrollView contentContainerStyle={styles.contentMinimal}>
                        <Text style={styles.title}>Emissão De Certidões</Text>

                        <View style={styles.container}>

                            <View style={styles.row}>
                                <Text style={styles.checkboxLabel} allowFontScaling={false}>
                                    Ao solicitar uma emissão de certidões da imoGo, você recebe, em até um dia útil, todas as certidões relativas a situação jurídica do proprietário e do imóvel, necessárias para a segurança da transação e o fechamento da venda.
                                </Text>
                            </View>

                            <View style={styles.row}>
                                <View style={styles.optionButtonsContainer}>
                                    <TouchableOpacity style={styles.optionButton} onPress={() => setModalVisible(true)}>
                                        <Image
                                            source={require('../assets/icons/plus.png')}
                                            style={styles.optionIcon}
                                        />
                                        <View style={styles.optionTextContainer}>
                                            <Text style={styles.optionTextTitle} allowFontScaling={false}>Solicitar nova emissão</Text>
                                        </View>
                                    </TouchableOpacity>
                                    <TouchableOpacity style={styles.optionButton} onPress={() => navigation.navigate('ListaAnaliseWeb', { usuario_id })}>
                                        <Image
                                            source={require('../assets/icons/files.png')}
                                            style={styles.optionIcon}
                                        />
                                        <View style={styles.optionTextContainer}>
                                            <Text style={styles.optionTextTitle} allowFontScaling={false}>Minhas emissões</Text>
                                        </View>
                                    </TouchableOpacity>
                                </View>
                            </View>

                            <View style={styles.buttonContainer}>
                                <TouchableOpacity style={styles.laterButton} onPress={() => navigation.navigate('Home', { usuario_id })}>
                                    <Image
                                        source={require('../assets/icons/home.png')}
                                        style={styles.laterIcon}
                                    />
                                    <Text style={styles.laterButtonText} allowFontScaling={false}>Voltar pra home</Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                        <Modal
                            visible={modalVisible}
                            animationType="slide"
                            transparent={true}
                            onRequestClose={() => setModalVisible(false)}
                        >

                            <View style={styles.modalOverlay}>
                                <View style={styles.modalContainer}>
                                    <TouchableOpacity style={styles.closeButton} onPress={() => setModalVisible(false)}>
                                        <Ionicons name="close" size={24} color="#FFF" />
                                    </TouchableOpacity>
                                    <Text style={styles.modalTitle} allowFontScaling={false}>Tipo de emissão: </Text>
                                    <View style={styles.categoryContainer}>
                                        <TouchableOpacity style={styles.categoryButton} onPress={() => { closeMenu(); navigation.navigate('EtapasAnaliseWeb', { usuario_id, status: 1 }) }}>
                                            <Image
                                                source={require('../assets/icons/2perfil.png')}
                                                style={styles.categoryIcon}
                                            />
                                            <Text style={styles.categoryText} allowFontScaling={false}>CPF</Text>
                                        </TouchableOpacity>
                                        <TouchableOpacity style={styles.categoryButton} onPress={() => { closeMenu(); navigation.navigate('EtapasAnaliseCNPJWeb', { usuario_id, status: 1 }) }}>
                                            <Image
                                                source={require('../assets/icons/cnpj.png')}
                                                style={styles.categoryIcon}
                                            />
                                            <Text style={styles.categoryText} allowFontScaling={false}>CNPJ</Text>
                                        </TouchableOpacity>
                                    </View>
                                </View>
                            </View>
                        </Modal>
                    </ScrollView>
                );
            }}
        </BaseWeb>
    );
}